import { apiSlice } from './apiSlice';

export const authApiSlice = apiSlice.injectEndpoints({
    endpoints: (builder) => ({
        login: builder.mutation({
            query: credentials => ({
                url: '/accounts/seller/login',
                method: 'POST',
                body: { ...credentials },
            }),
        }),
        signUp: builder.mutation({
            query: (userAccount) => ({
                url: 'Accounts/Seller',
                method: 'POST',
                body: userAccount,
            }),
        }),
        validateEmail: builder.query({
            query: ({ userId, token }: { userId: string, token: string }) => ({
                url: `/accounts/accountConfirm?userId=${userId}&token=${encodeURIComponent(token)}`,
            }),
        }),
        forgotPassword: builder.mutation({
            query: email => ({
                url: '/accounts/forgotPassword',
                method: 'POST',
                body: { ...email },
            }),
        }),
        resetPassword: builder.mutation({
            query: newPassword => ({
                url: '/accounts/passwordReset',
                method: 'POST',
                body: { ...newPassword },
            }),
        })
    }),
});

export const { useLoginMutation, useSignUpMutation, useValidateEmailQuery, useForgotPasswordMutation, useResetPasswordMutation } = authApiSlice;
